"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptStatisticsData = void 0;
class AttemptStatisticsData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AttemptStatisticsData.attributeTypeMap;
    }
}
exports.AttemptStatisticsData = AttemptStatisticsData;
AttemptStatisticsData.discriminator = undefined;
AttemptStatisticsData.attributeTypeMap = [
    {
        "name": "failureCount",
        "baseName": "failureCount",
        "type": "Array<number>",
        "format": "int"
    },
    {
        "name": "successCount",
        "baseName": "successCount",
        "type": "Array<number>",
        "format": "int"
    }
];
//# sourceMappingURL=AttemptStatisticsData.js.map